import { useI18n } from 'i18n-utils'
import { DefineComponentProps } from 'utils'
import './LoadMore.scss'

type LoadMoreProps = {
  loading: boolean
  noMore: boolean
  onLoadMore: () => void
  pageCount?: number
  pageCurrent?: number
  isEmpty?: boolean
}

export const LoadMore = defineComponent<LoadMoreProps>({
  props: DefineComponentProps<LoadMoreProps>(['loading', 'noMore', 'onLoadMore', 'isEmpty']),

  setup(props, { slots }) {
    const { t } = useI18n()
    return () => (
      <div class={'load-more-container'}>
        <div class="load-more-content">{slots.default?.()}</div>
        <div class="footer-load">
          {props.loading ? (
            <span class={'loading'}>{t('加载中...')}</span>
          ) : props.noMore ? (
            props.isEmpty ? (
              slots.empty?.() || null
            ) : (
              <span class={'no-more'}>{t('没有更多了')}</span>
            )
          ) : (
            <span class={'query-more'} onClick={props.onLoadMore}>
              {t('查看更多')}
            </span>
          )}
        </div>
      </div>
    )
  },
})
